import { ArrowRight } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';

import { GlassCard } from '../../app/components/ui/GlassCard';

import { CustomerActionsCard } from './components/CustomerActionsCard';
import { CustomerOrdersCard } from './components/CustomerOrdersCard';
import { CustomerServicesCard } from './components/CustomerServicesCard';
import { CustomerStatusBadge } from './components/CustomerStatusBadge';

import { useCustomer } from './hooks/useCustomer';


export function CustomerDetailsPage() {

  const { id } = useParams<{ id: string }>();

  const navigate = useNavigate();


  const {
    customer,
    loading,
    error,
  } = useCustomer(id);



  return (

    <div className="flex flex-col gap-4 sm:gap-5">


      <button
        type="button"
        onClick={() => navigate('/customers')}
        className="inline-flex w-fit items-center gap-1.5 text-sm text-[var(--vania-colors-text-secondary,#a3aab8)] hover:text-[var(--vania-colors-text-primary,#f5f6fa)]"
      >

        <ArrowRight size={16}/>

        بازگشت به مشتریان

      </button>



      {
        loading
        ?
        (
          <GlassCard>
            <p className="text-sm text-[var(--vania-colors-text-secondary,#a3aab8)]">
              در حال دریافت اطلاعات مشتری...
            </p>
          </GlassCard>
        )
        :
        error
        ?
        (
          <GlassCard>
            <p className="text-sm text-rose-400">
              {error}
            </p>
          </GlassCard>
        )
        :
        !customer
        ?
        (
          <GlassCard>
            <p className="text-sm text-[var(--vania-colors-text-secondary,#a3aab8)]">
              مشتری مورد نظر یافت نشد.
            </p>
          </GlassCard>
        )
        :
        (
          <>

            <GlassCard>

              <div className="flex items-center gap-4">

                <span className="flex h-14 w-14 items-center justify-center rounded-full bg-[var(--vania-colors-surface-secondary,rgba(255,255,255,0.08))] text-lg font-semibold">

                  {customer.name.charAt(0)}

                </span>


                <div className="flex-1">

                  <p className="font-semibold text-[var(--vania-colors-text-primary,#f5f6fa)]">
                    {customer.name}
                  </p>

                  <p className="text-sm text-[var(--vania-colors-text-secondary,#a3aab8)]">
                    {customer.contact}
                  </p>

                </div>


                <CustomerStatusBadge status={customer.status}/>


              </div>


              <div className="mt-4 grid grid-cols-2 gap-3 border-t border-[var(--vania-colors-border-subtle,rgba(255,255,255,0.08))] pt-4 sm:grid-cols-4">

                <div>
                  <p className="text-[11px] text-[var(--vania-colors-text-secondary,#a3aab8)]">
                    تاریخ عضویت
                  </p>
                  <p className="mt-0.5 text-sm text-[var(--vania-colors-text-primary,#f5f6fa)]">
                    {customer.joinedAt}
                  </p>
                </div>

                <div>
                  <p className="text-[11px] text-[var(--vania-colors-text-secondary,#a3aab8)]">
                    تعداد سفارش‌ها
                  </p>
                  <p className="mt-0.5 text-sm text-[var(--vania-colors-text-primary,#f5f6fa)]">
                    {customer.ordersCount.toLocaleString('fa-IR')}
                  </p>
                </div>

                <div>
                  <p className="text-[11px] text-[var(--vania-colors-text-secondary,#a3aab8)]">
                    مجموع خرید
                  </p>
                  <p className="mt-0.5 text-sm text-[var(--vania-colors-text-primary,#f5f6fa)]">
                    {customer.totalPurchases.toLocaleString('fa-IR')}
                  </p>
                </div>

                <div>
                  <p className="text-[11px] text-[var(--vania-colors-text-secondary,#a3aab8)]">
                    کمیسیون تولید شده
                  </p>
                  <p className="mt-0.5 text-sm text-[var(--vania-colors-text-primary,#f5f6fa)]">
                    {customer.generatedCommission.toLocaleString('fa-IR')}
                  </p>
                </div>

              </div>

            </GlassCard>


            <CustomerActionsCard />

            <CustomerServicesCard />

            <CustomerOrdersCard />


          </>
        )
      }


    </div>

  );
}
